import*as React from'react';const useEnhancedEffect=typeof window!=='undefined'?React.useLayoutEffect:React.useEffect;export default useEnhancedEffect;